
export default class Contacts {
    // This is an dictionary object, in the format iso:phonenumber, eg. AU:"+61290370028"
    constructor(json) {
        this.contacts = json;
    }
}